import * as React from "react";
import { memo } from "react";
const SvgTrash = (props) => (
  <svg viewBox="2 2 28 28" xmlns="http://www.w3.org/2000/svg" {...props}>
    <title />
    <g fill="none" stroke="currentColor">
      <rect
        className="cls-1"
        height={22}
        width={18}
        x={7}
        y={7}
        strokeWidth={2}
      />
      <line className="cls-1" x1={3} x2={29} y1={7} y2={7} strokeWidth={2} />
      <line className="cls-1" x1={13} x2={19} y1={3} y2={3} strokeWidth={2} />
      <line className="cls-1" x1={13} x2={13} y1={12} y2={22} strokeWidth={2} />
      <line className="cls-1" x1={19} x2={19} y1={12} y2={22} strokeWidth={2} />
    </g>
  </svg>
);
const Memo = memo(SvgTrash);
export default Memo;

